import { modules } from "../../main";

export abstract class CaspardoAPI  {
    public static async getSuggestions(api_url: string, sid: string, inputString: string, UUID: string, mandant_id: string, signal: any) {
        const url = `${api_url}hid=${mandant_id}&queryword=${encodeURIComponent(inputString)}&language=${modules.getLanguageCode()}&showplan=1&emulation=1&uuid=${UUID}`;

        try {
            const response = await fetch(url, { signal }); // Pass the signal to the fetch options

            if (response.ok) {
                // Check if the request was aborted
                if (signal && signal.aborted) {
                    return { autocomplete: [] };
                }

                const data = await response.json();
                return data;
            } else {
                throw new Error(`Request failed with status ${response.status}`);
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                // Request was aborted, handle it as needed
                console.log('Request was aborted:', error.message);
            } else {
                // Handle other types of errors
                console.error('Error in fetch:', error);
            }
            throw error;
        }
    }
}